import BagCarryOn from 'mdi-material-ui/BagCarryOn';
import CarBattery from 'mdi-material-ui/CarBattery';
import CarKey from 'mdi-material-ui/CarKey';
import CarMultiple from 'mdi-material-ui/CarMultiple';
import CarTireAlert from 'mdi-material-ui/CarTireAlert';
import CarWindshield from 'mdi-material-ui/CarWindshield';
import CarWrench from 'mdi-material-ui/CarWrench';
import MedicalBag from 'mdi-material-ui/MedicalBag';
import RacingHelmet from 'mdi-material-ui/RacingHelmet';
import ShieldCar from 'mdi-material-ui/ShieldCar';
import ShieldCheckOutline from 'mdi-material-ui/ShieldCheckOutline';
import TowTruck from 'mdi-material-ui/TowTruck';
import Umbrella from 'mdi-material-ui/Umbrella';
import Web from 'mdi-material-ui/Web';

import { ReactComponent as ThiefIcon } from 'app/assets/icons/thief.svg';
import { ReactComponent as ShieldPercentIcon } from 'app/assets/icons/shieldPercent.svg';
import { ReactComponent as Ball } from 'app/assets/icons/basketball.svg';
import { ReactComponent as Stethoscope } from 'app/assets/icons/stethoscope.svg';
import { ReactComponent as Plane } from 'app/assets/icons/plane.svg';
import { ReactComponent as Skiing } from 'app/assets/icons/skiing.svg';
import { ReactComponent as Snowflake } from 'app/assets/icons/snowflake.svg';
import { UpsaleRiskIcon } from 'app/shared/interfaces/UpsaleRisk.interface';
import { UpsaleRiskTypeEnum } from 'app/shared/enums';

export const upsaleRiskIconConfig: UpsaleRiskIcon = {
  [UpsaleRiskTypeEnum.Ac]: ShieldCar,
  [UpsaleRiskTypeEnum.AcMini]: ShieldCar,
  [UpsaleRiskTypeEnum.Assistance]: TowTruck,
  [UpsaleRiskTypeEnum.AssistanceTowing]: TowTruck,
  [UpsaleRiskTypeEnum.Bls]: CarWrench,
  [UpsaleRiskTypeEnum.CarBattery]: CarBattery,
  [UpsaleRiskTypeEnum.Glass]: CarWindshield,
  [UpsaleRiskTypeEnum.LegalProtection]: ShieldCheckOutline,
  [UpsaleRiskTypeEnum.Luggage]: BagCarryOn,
  [UpsaleRiskTypeEnum.Medic]: MedicalBag,
  [UpsaleRiskTypeEnum.MotorcycleAccessories]: RacingHelmet,
  [UpsaleRiskTypeEnum.Nnw]: Umbrella,
  [UpsaleRiskTypeEnum.ReplacementCar]: CarMultiple,
  [UpsaleRiskTypeEnum.ReplacementCarDays]: CarKey,
  [UpsaleRiskTypeEnum.Tire]: CarTireAlert,
  [UpsaleRiskTypeEnum.Keys]: CarKey,
  [UpsaleRiskTypeEnum.HelpAfterTheft]: ThiefIcon,
  [UpsaleRiskTypeEnum.DiscountProtection]: ShieldPercentIcon,
  [UpsaleRiskTypeEnum.Greencard]: Web,
  [UpsaleRiskTypeEnum.CarRent]: ShieldCar,
  [UpsaleRiskTypeEnum.OcSport]: Ball,
  [UpsaleRiskTypeEnum.ContinuationTreatment]: Stethoscope,
  [UpsaleRiskTypeEnum.Plane]: Plane,
  [UpsaleRiskTypeEnum.Freeride]: Skiing,
  [UpsaleRiskTypeEnum.SkiPackage]: Snowflake,
  [UpsaleRiskTypeEnum.WinterPackage]: Snowflake,
};
